import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Logo } from '@els/els-react--logo';
import { Button } from '@els/els-react--button';
import { TextInput } from '@els/els-react--text-input';
import { validateEmail } from '@Utils/Email';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';
import LoginPageWrapper from '../Components/LoginPageWrapper';

import './ActivatingId.scss';

function ActivatingId({ isLoading, emailSubmit }) {
  const [email, setEmail] = useState('');
  const [emailInvalid, setEmailInvalid] = useState(false);

  const onSubmit = () => {
    if (isLoading) {
      return;
    }

    if (validateEmail(email)) {
      setEmailInvalid(false);
      emailSubmit(email);
    } else {
      setEmailInvalid(true);
    }
  };

  const onInputKeyDown = (event) => {
    if (event.key === 'Enter') {
      onSubmit();
    }
  };

  return (
    <LoginPageWrapper className="react-page-activating-id-page" mainAriaLabel="Activating registration ID screen">
      <div className="activating-id-dialog__content">
        <div className="activating-id-dialog__header">
          <Logo className="activating-id-dialog__logo" />
        </div>

        <h1 className="activating-id-dialog__title u-els-font-size-h4 u-els-padding-bottom">Activating a registration ID</h1>

        <p className="activating-id-dialog__description">
          You are activating a registration ID. Validate your email account to continue with the redemption process.
        </p>

        <TextInput
          id="bulk-id-email"
          label="Email account"
          placeholder="Enter your email"
          autoComplete="email"
          required
          value={email}
          onChange={(e) => setEmail(e?.target?.value)}
          onKeyDown={onInputKeyDown}
          data-e2e="bulk-id-email-input"
          className="e2e-bulk-id-email-input activating-id-dialog__input"
          isInvalid={emailInvalid}
          invalidMessage={emailInvalid ? 'Incorrect email address' : undefined}
          autoFocus
        />

        {isLoading && <SimpleSpinner />}

        <Button
          type="primary"
          expanded
          onClick={onSubmit}
          data-e2e="bulk-id-email-submit-button"
          className="e2e-bulk-id-email-continue activating-id-dialog__button">
          Continue
        </Button>
      </div>
    </LoginPageWrapper>
  );
}

ActivatingId.propTypes = {
  isLoading: PropTypes.bool,
  emailSubmit: PropTypes.func.isRequired,
};

export default ActivatingId;
